import { NavLink } from "../core/layouts/types";
import {
  adminCat,
  builderCat,
  manufacturingCat,
  merchantCat,
} from "../core/utils/constants";
import { UserRole } from "../redux/features/user-slice";
import paths from "./paths";

export const navigation: NavLink[] = [
  {
    id: "dailyReports",
    type: "link",
    title: "Daily Reports",
    path: paths.DAILY_REPORTS,
    category: [],
    role: [
      UserRole.Manager,
      UserRole.Leader,
      UserRole.Contributor,
      UserRole.Member,
    ],
  },
  {
    id: "weeklyReports",
    type: "link",
    title: "Weekly Reports",
    path: paths.WEEKLY_REPORTS,
    category: [],
    role: [
      UserRole.Manager,
      UserRole.Leader,
      UserRole.Contributor,
      UserRole.Member,
    ],
  },
  {
    id: "categories",
    type: "link",
    title: "Categories",
    path: paths.CATEGORIES,
    category: [],
    role: [UserRole.Manager, UserRole.Leader],
  },
  {
    id: "categoriesManagement",
    type: "link",
    title: "Categories",
    category: [],
    role: [UserRole.Admin, UserRole.Supervisor],
    child: [
      {
        id: `${paths.CATEGORIES}/${adminCat.name}/${adminCat.id}`,
        type: "link",
        title: adminCat.name,
        path: `${paths.CATEGORIES}/${adminCat.name}/${adminCat.id}`,
        category: [adminCat.id],
        role: [UserRole.Admin, UserRole.Supervisor],
      },
      {
        id: `${paths.CATEGORIES}/${manufacturingCat.name}/${manufacturingCat.id}`,
        type: "link",
        title: manufacturingCat.name,
        path: `${paths.CATEGORIES}/${manufacturingCat.name}/${manufacturingCat.id}`,
        category: [adminCat.id, manufacturingCat.id],
        role: [UserRole.Admin, UserRole.Supervisor],
      },
      {
        id: `${paths.CATEGORIES}/${merchantCat.name}/${merchantCat.id}`,
        type: "link",
        title: merchantCat.name,
        path: `${paths.CATEGORIES}/${merchantCat.name}/${merchantCat.id}`,
        category: [adminCat.id, merchantCat.id],
        role: [UserRole.Admin, UserRole.Supervisor],
      },
      {
        id: `${paths.CATEGORIES}/${builderCat.name}/${builderCat.id}`,
        type: "link",
        title: builderCat.name,
        path: `${paths.CATEGORIES}/${builderCat.name}/${builderCat.id}`,
        category: [adminCat.id, builderCat.id],
        role: [UserRole.Admin, UserRole.Supervisor],
      },
    ],
  },
  {
    id: "workCalendar",
    type: "link",
    title: "Work Calendar",
    path: paths.WORK_CALENDAR,
    category: [],
    role: [],
  },
  {
    id: "usersManagement",
    type: "section",
    title: "Users Management",
    category: [adminCat.id],
    role: [UserRole.Admin, UserRole.Supervisor],
  },
  {
    id: "users",
    type: "link",
    title: "Users",
    path: paths.USERS,
    category: [adminCat.id],
    role: [UserRole.Admin, UserRole.Supervisor],
  },
  {
    id: "addUser",
    type: "link",
    title: "Add User",
    path: paths.ADD_USER,
    category: [adminCat.id],
    role: [UserRole.Admin, UserRole.Supervisor],
  },
  {
    id: "customersManagement",
    type: "section",
    title: "Customers Management",
    category: [],
    role: [UserRole.Admin, UserRole.Trainer],
  },
  {
    id: paths.ADD_CUSTOMER,
    type: "link",
    title: "Add Customer",
    path: paths.ADD_CUSTOMER,
    category: [],
    role: [UserRole.Admin, UserRole.Trainer],
  },
  {
    id: paths.CUSTOMERS,
    type: "link",
    title: "Customers",
    path: paths.CUSTOMERS,
    category: [],
    role: [UserRole.Admin, UserRole.Trainer],
  },
  {
    id: "data",
    type: "section",
    title: "Data",
    category: [],
    role: [],
  },
  {
    id: "reports",
    type: "link",
    title: "Export Reports",
    path: paths.EXPORT_REPORTS,
    category: [],
    role: [],
  },
  {
    id: "schedules",
    type: "link",
    title: "Schedule Reports",
    path: paths.SCHEDULE_REPORTS,
    category: [],
    role: [],
  },
  {
    id: "addschedule",
    type: "link",
    title: "Add Schedule Reports",
    path: paths.ADD_SCHEDULE_REPORT,
    category: [],
    role: [],
  },
  {
    id: "incidentsdashboard",
    type: "link",
    title: "Customer support",
    path: paths.INCIDENTS_DASHBOARD,
    category: [],
    role: [],
  },
  {
    id: "myTeamLearning",
    type: "section",
    title: "MyTeam Learning",
    category: [],
    role: [],
  },
  {
    id: `${paths.COURSES}`,
    type: "link",
    title: "Teaching",
    path: `${paths.COURSES}`,
    category: [],
    role: [],
  },
  {
    id: `${paths.COURSES_USER}`,
    type: "link",
    title: "Learning",
    path: `${paths.COURSES_USER}`,
    category: [],
    role: [],
  },
  {
    id: "myTeamRecruitment",
    type: "section",
    title: "MyTeam Recruitment",
    category: [],
    role: [UserRole.Admin, UserRole.Contributor],
  },
  {
    id: `${paths.JDS}`,
    type: "link",
    title: "JDS",
    path: `${paths.JDS}`,
    category: [],
    role: [UserRole.Admin, UserRole.Contributor],
  },
  {
    id: `${paths.CANDIDATES}`,
    type: "link",
    title: "Candidates",
    path: `${paths.CANDIDATES}`,
    category: [],
    role: [UserRole.Admin, UserRole.Contributor],
  },
];
